uniform sampler2D uTexture; 
uniform vec2 uMouse; 
uniform float time;
varying vec2 vUv;
varying float vCircleIntensity;

void main() {  
    vec4 finalTexture = texture2D(uTexture, vUv);
    
    // Create a color gradient that changes over time
    // Dark purple, dark orange, and dark blue
	vec3 color1 = vec3(0.4, 0.0, 0.4); // Dark purple
	vec3 color2 = vec3(0.8, 0.4, 1.0); // Dark orange
	vec3 color3 = vec3(0.0, 0.0, 0.0); // Dark blue

	// Animate the colors over time
	vec3 animatedColor1 = mix(color1, vec3(0.0, 0.0, 5.5), 0.5 + 0.5 * sin(time)); // Slightly animate dark purple
	vec3 animatedColor2 = mix(color2, vec3(0.0, 5.6, 0.0), 0.5 + 0.5 * cos(time * 0.5)); // Slightly animate dark orange
	vec3 animatedColor3 = mix(color3, vec3(5.0, 0.0, 0.6), 0.5 + 0.5 * sin(time * 0.7)); // Slightly animate dark blue

	// Calculate the distance from the center of the circle (uMouse mapped to UV space)
    float dist = distance(vUv, (uMouse * 0.5) + 0.5);

    // Define the radius for the inner empty area and the outer edge
    float innerRadius = 0.0;
    float outerRadius = 1.0;

	// Create a ring gradient
    float ringIntensity = smoothstep(innerRadius, outerRadius, dist);
	
	vec3 gradientColor = mix(animatedColor1, animatedColor2, sin(time + vCircleIntensity * 5.0) * 0.5 + 0.5);
	gradientColor = mix(gradientColor, animatedColor3, sin(time * 0.5 + vCircleIntensity * 3.0) * 0.5 + 0.5);

	float noise = fract(sin(dot(vUv, vec2(12.9898,78.233))) * 43758.5453);
	gradientColor += noise * 0.1;  // Adjust the factor to control the strength of the noise

	vec3 lightDir = normalize(vec3(0.5, 0.5, 1.0));
	float lightIntensity = dot(normalize(vec3(vUv - 0.5, 0.1)), lightDir) * 0.5 + 0.5;
	gradientColor *= lightIntensity;

    float phaseShift = sin(time) * 10.0; // Phase shift changes over time
	// float pattern = sin(vUv.x * 50.0 + time + phaseShift) * sin(vUv.y * 50.0 + time + phaseShift) * 0.1;
	
	float checker = step(1.5, mod(floor(vUv.x * 10.0) + floor(vUv.y * 10.0), 2.0));

	float amplitude = 0.1 + sin(time * 2.0) * 0.05; // Amplitude changes over time
	// float pattern = sin(vUv.x * 50.0 + time + phaseShift) * sin(vUv.y * 50.0 + time + phaseShift) * 0.1;
	// float pattern = sin(vUv.x * 0.0 + time) * sin(vUv.y * 0.0 + time) * amplitude;
	
	// gradientColor += pattern;

    // Blend the gradient color with the texture
    // vec4 finalColor = mix(finalTexture, vec4(gradientColor, 1.0), ringIntensity);
	vec4 finalColor = vec4(gradientColor * finalTexture.rgb, 1.0);

    csm_DiffuseColor = finalColor; 
}